var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isIe)?_c('div',{staticClass:"ie_main"},[_c('img',{attrs:{"src":require("@/assets/images/1.png"),"alt":""}}),_vm._m(0)]):_c('div',[_c('Header',{ref:"header"}),_c('router-view'),_c('Footer',{ref:"footer"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 当前浏览器内核为兼容模式，无法正常显示， "),_c('br'),_vm._v(" 参考图片，请点击网址输入框右边的符号，切换为极速模式 ")])
}]

export { render, staticRenderFns }